// datetime-local is browser-local wall time. Date chooses the first occurrence
// of repeated fall-back times; round-trip every component to reject DST gaps.
export function scheduleTime(value, now = new Date()) {
  const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const invalid = { zone, utc: '', offset: '', error: 'Choose a valid future local date and time. Times skipped by daylight saving are not available.' };
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(value)) return invalid;
  const parts = value.split(/[-T:]/).map(Number);
  const date = new Date(value);
  const actual = [date.getFullYear(), date.getMonth() + 1, date.getDate(), date.getHours(), date.getMinutes()];
  if (!Number.isFinite(date.getTime()) || parts.some((part, i) => part !== actual[i]) || date <= now) return invalid;
  const minutes = -date.getTimezoneOffset();
  const pad = n => String(n).padStart(2, '0');
  const offset = `UTC${minutes >= 0 ? '+' : '-'}${pad(Math.floor(Math.abs(minutes) / 60))}:${pad(Math.abs(minutes) % 60)}`;
  return { zone, utc: date.toISOString(), offset, error: '' };
}
